"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TheDarksideofTheMoonSyndicate = void 0;
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const CardRenderer_1 = require("../render/CardRenderer");
const ResourceType_1 = require("../../ResourceType");
const MoonExpansion_1 = require("../../moon/MoonExpansion");
const Multiset_1 = require("../../utils/Multiset");
const Resources_1 = require("../../Resources");
const OrOptions_1 = require("../../inputs/OrOptions");
const SelectOption_1 = require("../../inputs/SelectOption");
const StealResources_1 = require("../../deferredActions/StealResources");
const Size_1 = require("../render/Size");
const Phase_1 = require("../../Phase");
const Card_1 = require("../Card");
class TheDarksideofTheMoonSyndicate extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.THE_DARKSIDE_OF_THE_MOON_SYNDICATE,
            tags: [Tags_1.Tags.MOON],
            startingMegaCredits: 40,
            resourceType: ResourceType_1.ResourceType.SYNDICATE_FLEET,
            metadata: {
                cardNumber: 'MC3',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.megacredits(40).syndicateFleet(2).br;
                    b.text('You start with 40 M€ and 2 syndicate fleets.', Size_1.Size.SMALL, false, false);
                    b.corpBox('effect', (ce) => {
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.effect('When you place a tile on the Moon, steal 2 M€ from each player for each adjacency.', (eb) => {
                            eb.emptyTile('normal', Size_1.Size.SMALL).secondaryTag(Tags_1.Tags.MOON).startEffect.text('STEAL', Size_1.Size.SMALL).nbsp().megacredits(2).any.slash().emptyTile('normal', Size_1.Size.SMALL).emptyTile('normal', Size_1.Size.SMALL).any;
                        });
                        ce.vSpace(Size_1.Size.SMALL);
                        ce.action('Spend 1 titanium to add 1 syndicate fleet here OR remove 1 syndicate fleet from this card to steal 8 M€ from any player.', (eb) => {
                            eb.titanium(1).startAction.syndicateFleet().slash(Size_1.Size.SMALL).syndicateFleet().arrow().megacredits(8).any;
                        });
                    });
                }),
            },
        });
        this.resourceCount = 0;
    }
    play(player) {
        player.addResourceTo(this, 2);
        return undefined;
    }
    canAct(player) {
        return player.titanium > 0 || this.resourceCount > 0;
    }
    action(player) {
        const orOptions = new OrOptions_1.OrOptions();
        if (player.titanium > 0) {
            orOptions.options.push(new SelectOption_1.SelectOption('Spend 1 titanium to add 1 syndicate fleet to this card', 'Add syndicate fleet', () => {
                player.titanium--;
                player.addResourceTo(this);
                return undefined;
            }));
        }
        if (this.resourceCount > 0) {
            orOptions.options.push(new SelectOption_1.SelectOption('Remove 1 syndicate fleet from this card to steal 8 M€ from any player', 'Remove syndicate fleet', () => {
                player.removeResourceFrom(this);
                player.game.defer(new StealResources_1.StealResources(player, Resources_1.Resources.MEGACREDITS, 8));
                return undefined;
            }));
        }
        if (orOptions.options.length === 1) {
            return orOptions.options[0].cb();
        }
        return orOptions;
    }
    onTilePlaced(cardOwner, activePlayer, space) {
        if (activePlayer.game.phase === Phase_1.Phase.SOLAR) {
            return;
        }
        if (activePlayer !== cardOwner) {
            return undefined;
        }
        if (space.tile === undefined) {
            return undefined;
        }
        const game = activePlayer.game;
        if (MoonExpansion_1.MoonExpansion.MOON_TILES.has(space.tile.tileType)) {
            const costs = new Multiset_1.Multiset();
            MoonExpansion_1.MoonExpansion.moonData(game).moon.getAdjacentSpaces(space).forEach((space) => {
                if (space.tile !== undefined && space.player !== undefined && space.player !== activePlayer) {
                    costs.add(space.player, 2);
                }
            });
            costs.entries().forEach(([target, qty]) => {
                const adjustedQuantity = Math.min(qty, target.megaCredits);
                activePlayer.addResource(Resources_1.Resources.MEGACREDITS, adjustedQuantity, { log: true });
                target.deductResource(Resources_1.Resources.MEGACREDITS, adjustedQuantity, { log: true, from: activePlayer });
            });
        }
        return undefined;
    }
}
exports.TheDarksideofTheMoonSyndicate = TheDarksideofTheMoonSyndicate;
//# sourceMappingURL=TheDarksideofTheMoonSyndicate.js.map